module.exports = __webpack_public_path__ + "static/media/close_black.0a9b0d3a.svg";